module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "system-builder__contact-dealer--scroll-wrap"
  }, [_c('div', {
    staticClass: "system-builder__contact-dealer--dealers-container"
  }, [_c('div', {
    staticClass: "system-builder__contact-dealer--final-nav"
  }, [_c('span', {
    on: {
      "click": _vm.editContactForm
    }
  }, [_vm._v("Edit Contact Info")])]), _vm._v(" "), _c('h4', [(_vm.sharedState.dealers === null) ? _c('span', [_vm._v("Submit the form below to find and get a quote from a local dealer!")]) : (_vm.getNumberDealers === 1) ? _c('span', {
    staticClass: "system-builder__dealer-count"
  }, [_vm._v("\n        Great! There is 1 dealer near " + _vm._s(_vm.sharedState.customerDetails.customerZip) + ".\n      ")]) : (_vm.getNumberDealers === 0) ? _c('span', {
    staticClass: "system-builder__dealer-count"
  }, [_vm._v("\n        Sorry, there are no dealers located near" + _vm._s(_vm.sharedState.customerDetails.customerZip) + ".\n      ")]) : _c('span', {
    staticClass: "system-builder__dealer-count"
  }, [_vm._v("\n        Great! There are " + _vm._s(_vm.getNumberDealers) + " dealers near " + _vm._s(_vm.sharedState.customerDetails.customerZip) + ".\n      ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-bottom": "25px"
    }
  }, [_vm._v("Call, visit, or request an e-quote to get more information from your local dealer.")]), _vm._v(" "), (_vm.sharedState.dealers === null) ? _c('div', {
    staticClass: "system-builder__contact-dealer--dealers-container-alt"
  }, [_c('spinner', {
    attrs: {
      "size": "large",
      "message": "Loading dealers nearby..."
    }
  })], 1) : _c('div', {
    staticClass: "system-builder__contact-dealer--dealer-items-container"
  }, _vm._l((_vm.sharedState.dealers), function(dealer, index) {
    return _c('dealerItem', {
      key: dealer.ID,
      attrs: {
        "dealerId": dealer.ID,
        "dealerPro": dealer.custom_fields.tx_wpsl_store_category[0],
        "dealerPhone": _vm.checkPropForValue(dealer.custom_fields.wpsl_phone[0]),
        "dealerEmail": dealer.custom_fields.wpsl_email[0]
      }
    }, [_c('div', {
      slot: "dealer-details"
    }, [_c('h5', [_vm._v(_vm._s(dealer.post_title) + " - "), _c('span', {
      staticClass: "system-builder__dealer-distance"
    }, [_vm._v(_vm._s(dealer.distance) + " Miles")])]), _vm._v(" "), _c('p', [_vm._v("\n            " + _vm._s(dealer.custom_fields.wpsl_address[0])), _c('br'), _vm._v("\n            " + _vm._s(dealer.custom_fields.wpsl_city[0]) + ", " + _vm._s(dealer.custom_fields.wpsl_state[0]) + " " + _vm._s(dealer.custom_fields.wpsl_zip[0])), _c('br'), _vm._v(" "), (_vm.checkPropForValue !== false) ? _c('span', [_vm._v(_vm._s(dealer.custom_fields.wpsl_phone[0]))]) : _vm._e()])])])
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7031ee09","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/steps/DealerList.vue
// module id = 424
// module chunks = 1